import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../services/auth.service';

class StatusesAndEntity {
  statuses?: string[];
  entity?: any;
}

@Directive({
  selector: '[awIsInAnyStatus]'
})
export class IsInAnyStatusDirective implements OnInit, OnDestroy {

  private hasView = true;
  private statusesAndEntity?: StatusesAndEntity;

  constructor(
    private authService: AuthService,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) {
  }

  @Input() set awIsInAnyStatus(statusesAndEntity: StatusesAndEntity) {
    this.statusesAndEntity = statusesAndEntity;
  }

  ngOnInit(): void {
    this.viewContainer.clear();
    this.hasView = false;
    if (this.hasView && this.statusesAndEntity?.statuses?.find(status => this.statusesAndEntity?.entity.status === status)) {
      this.viewContainer.clear();
      this.hasView = false;
    } else if (!this.hasView && this.statusesAndEntity?.statuses?.find(status => this.statusesAndEntity?.entity.status === status)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    }
  }

  ngOnDestroy(): void {
  }

}
